import { FC, useState } from "react";
import Cropper from "react-easy-crop";
import { Modal, ModalBaseProps } from ".";
import getCroppedImg from "utils/image-cropper";
import { dataURLtoFile, notify } from "utils";
import { IconButton } from "components/buttons";

interface props extends ModalBaseProps {
  cropShape: "rect" | "round";
  imageSource: string | null;
  onSubmit: (file: File) => void;
}

export const ImageResizeModal: FC<props> = (props) => {
  const [zoom, setZoom] = useState(1);
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  const [value, setValue] = useState<{ dataUrl: string; name: string } | null>(
    null
  );

  const onSubmit = async () => {
    if (value) {
      try {
        dataURLtoFile(value.dataUrl, value.name).then((file) => {
          props.onSubmit(file);
        });
      } catch (error) {
        notify({
          type: "error",
          message: "خطا در بارگذاری تصویر",
        });
      }
    }
  };

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <>
        <div className="flex-1 relative" style={{ height: 350 }}>
          <Cropper
            image={props.imageSource!}
            cropShape={props.cropShape}
            crop={crop}
            rotation={0}
            objectFit={"vertical-cover"}
            zoom={zoom}
            aspect={props.cropShape == "round" ? 1 / 1 : 1.25}
            onCropChange={setCrop}
            onCropComplete={(croppedArea, croppedAreaPixels) => {
              getCroppedImg(props.imageSource!, croppedAreaPixels).then((f) =>
                setValue(f)
              );
            }}
            onZoomChange={setZoom}
          />
        </div>
        <div className="grid grid-cols-1 gap-4 py-4">
          <button
            className="btn btn-block bg-primary btn-sm h-[42px] py-0 pe-1 mt-2"
            onClick={onSubmit}
          >
            <div className="flex items-center w-full">
              <div className="flex-1 text-start">ثبت </div>
              <IconButton
                size="sm"
                iconName="ArrowLeft"
                contentColor="#121212"
                backgroundColor="#D7AC00"
              />
            </div>
          </button>
          <button className="btn btn-block btn-ghost" onClick={props.onClose}>
            انصراف
          </button>
        </div>
      </>
    </Modal>
  );
};
